import React from 'react';
import { Typography, Image } from 'antd';
const { Title, Paragraph } = Typography;

const ForRefinersByRefiners = () => {
  return (
    <div>
        <div >
            <Title level={1}>Technology Developed By Refiners For Refiners</Title>
        </div>
        <div>
        <Image 
          src="/images/lab-tech-4-web.jpg"
          alt="about TEMA hero"
          preview={false}
        />
        </div>
        <div>
            <Paragraph className="common-paragraph">
            Technology Marketing (TEMA) is the hydroprocessing and refinery technology
            commercialization center of excellence for Chevron Corporation. TEMA has about 120
            employees in areas of hydroprocessing research and development, process and mechanical
            design, catalyst manufacture, project execution, technical service, technology sales and
            marketing, and joint venture operations.
            </Paragraph>
            <Paragraph className="common-paragraph">
            We encourage you to explore our website and learn about Chevron Lummus Global (CLG) and
            Advanced Refining Technologies (ART) &ndash; joint venture companies through which
            Technology Marketing offers Chevron premier, proven hydroprocessing technologies and
            catalysts. And, discover ZeolitePlus, a low cost, high throughput manufacturing route to
            zeolites, along with MERCAWAY&#8480; process technology, a straightforward process for
            reducing mercury content in crude oil and condensate.
            </Paragraph>
        </div>
    </div>
  );
};

export default ForRefinersByRefiners;